import { useEffect, useState } from 'react';
import { WORDPRESS_ACTIVE_SESSION_COOKIE } from '@/lib/middleware/wordpress';

export const useHasWPSession = () => {
  const [hasWPSession, setHasWPSession] = useState(false);
  useEffect(() => {
    const wpCookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith(`${WORDPRESS_ACTIVE_SESSION_COOKIE}=`))
      ?.split('=')[1];
    if (wpCookieValue === '1') {
      setHasWPSession(true);
    }
  }, []);
  return { hasWPSession };
};
